
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'agreement-status-badge',
    props: {
        status: {
            type: String,
            required: true
        }
    },
    setup (props) {
        function badgeColor () {
            switch (props.status) {
            case 'active': return 'positive'
            case 'expired': return 'accent'
            case 'cancelled':
            case 'canceled': return 'negative'
            case 'draft':
            default: return 'grey-6'
            }
        }

        return {
            badgeColor
        }
    }
})
